export default __webpack_public_path__ + "static/media/banner3.b2048d02.jpeg";